import { commonTexts, enrollmentTexts } from 'consts/text';
import { UserCheckBottomIcon } from 'assets';
import {
    AppConfirmModal,
    AppConfirmModalProps,
} from 'components/organisms/AppConfirmModal/AppConfirmModal';
import styled from 'styled-components';

const StyledUserCheckBottomIcon = styled(UserCheckBottomIcon)`
    width: 48px;
    height: 48px;
`;

export const ChildEnrollmentApproveModal = ({
    open,
    onCancel,
}: Pick<AppConfirmModalProps, 'open' | 'onCancel'>) => (
    // TODO: to add mutation logic
    <AppConfirmModal
        open={open}
        isMobileFullScreenMode={false}
        // TODO: to pass loading status from useAppMutation
        // confirmActionLoading={}
        title={enrollmentTexts.approveChildEnrollment.title}
        text={enrollmentTexts.approveChildEnrollment.description}
        icon={<StyledUserCheckBottomIcon />}
        width={420}
        okButtonProps={{
            title: enrollmentTexts.approveChildEnrollment.okButtonText,
        }}
        cancelButtonProps={{ title: commonTexts.actionLabels.goBack }}
        // TODO: to pass mutate function from useAppMutation
        // onOk={}
        onCancel={onCancel}
    />
);
